import { useEffect, useState } from 'react';

import { IEventItem } from '../../store/player/events/store';

import { getEventAvailableEntries } from '../Utils/getEventAvailableEntries';

export const useEventEntriesAvailable = (event: IEventItem) => {
  const [entriesAvailable, setEntriesAvailable] = useState(0);

  useEffect(() => {
    setEntriesAvailable(getEventAvailableEntries(event));
  }, [event]);

  return [entriesAvailable];
};
